<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Calendario de obras</h2></v-toolbar-title></pre>
                    </v-toolbar>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <router-link to="lista-plan-orden">
                        <v-btn
                            color="red"
                            class="white--text"
                            style="margin-left: 1rem"
                            >Volver</v-btn
                        >
                    </router-link>
                </v-col>
                <v-col cols="12">
                    <div class="d-flex gap-3 flex-wrap align-center">
                        <template v-for="item in estados_orden">
                            <div
                                class="d-flex gap-2 align-center mr-3 pointer"
                                @click="
                                    getordenes(
                                        fecha_inicio,
                                        fecha_fin,
                                        item.value
                                    )
                                "
                            >
                                <div
                                    class="filter-bullet"
                                    :style="{ backgroundColor: item.color }"
                                ></div>
                                <span>{{ item.label }}</span>
                            </div>
                        </template>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <planPicker
                        v-model="Seguimiento"
                        :filter="current_estado"
                        @referesh="getordenes"
                    ></planPicker>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import { debounce } from "../../../helpers";
import planPicker from "../../../components/general/planpicker/planordenpicker.vue";
export default {
    components: {
        planPicker,
    },

    data() {
        return {
            rol: 0,
            clientes: [],
            seguimiento: {},
            agentes: {},
            Seguimiento: [],
            controles: [],
            acciones: [],
            productos: [],
            estados_orden: [
                { value: 1, color: "#fb8c00", label: "Solicitada" },
                { value: 9, color: "#1987d2", label: "Facturado" },
                { value: null, color: "#4caf50", label: "Todos" },
            ],
            fecha_inicio: null,
            fecha_fin: null,
            current_estado: null,
        };
    },

    created() {
        this.fecha_inicio = new Date();
        this.fecha_inicio.setDate(
            this.fecha_inicio.getDate() - this.fecha_inicio.getDay() + 1
        );
        this.fecha_fin = new Date();
        this.fecha_fin.setDate(
            this.fecha_fin.getDate() - this.fecha_fin.getDay() + 5
        );
        this.getordenes(this.fecha_inicio, this.fecha_fin);
        //this.getClientes();
    },
    methods: {
        Filtrar() {
            axios
                .get(
                    `api/get-seguimiento-cliente/${this.seguimiento.id_cliente}`
                )
                .then(
                    (res) => {
                        this.Seguimientos = res.data.seguimientos;

                        //console.log(this.Seguimientos);
                    },
                    (err) => {
                        this.$custom_error(
                            "Error consultando los seguimientos"
                        );
                    }
                );
        },
        getProductos() {
            axios.get(`api/get-productos`).then(
                (res) => {
                    this.productos = res.data.Productos;
                },
                (res) => {}
            );
        },
        getControles() {
            axios.get(`api/get-seguimiento-controles`).then(
                (res) => {
                    let data = res.data;
                    this.controles = data.controles;
                },
                (res) => {}
            );
        },
        getAcciones() {
            axios.get(`api/get-seguimiento-acciones`).then(
                (res) => {
                    let data = res.data;
                    this.acciones = data.acciones;
                },
                (res) => {}
            );
        },
        SearchCliente: debounce(function (val) {
            this.$store.dispatch("searchCliente", val);
        }, 500),
        endIntersect(entries, observer, isIntersecting) {
            if (isIntersecting) {
                this.$store.dispatch("getClientesNext", this);
            }
        },
        getClientes() {
            axios.get(`api/get-clientes/-1`).then(
                (res) => {
                    this.clientes = res.data.data;
                },
                (res) => {}
            );
        },
        getAgentes() {
            axios.get(`api/get-agentes`).then(
                (res) => {
                    this.agentes = res.data.Agentes;
                },
                (res) => {}
            );
        },
        getordenes(fecha_inicio = null, fecha_fin = null, id_estado = null) {
            this.fecha_inicio = fecha_inicio;
            this.fecha_fin = fecha_fin;
            this.current_estado = id_estado;
            axios
                .get(`api/get-planes-orden`, {
                    params: {
                        fecha: fecha_inicio,
                        fecha_fin: fecha_fin,
                        id_estado: this.current_estado,
                    },
                })
                .then(
                    (res) => {
                        this.Seguimiento = res.data.data;
                    },
                    (err) => {
                        this.$custom_error("Error consultando las obras");
                    }
                );
        },
        formatNumber(number) {
            return Number.parseFloat(number.toString())
                .toFixed(2)
                .replace(".", ",")
                .replace(",00", "");
        },
    },
    filters: {},

    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
    },
};
</script>
<style>
.rowtwo {
    display: flex;
    flex-direction: row;
}
.spacing {
    padding-top: 0 !important;
}
.filter-bullet {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 5px;
}
</style>
